"use client";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useInputHelperText } from "../../../building-blocks/inputs/InputHelperText.js";
import { ScreenReaderOnly } from "../../../utilities/accessibility/ScreenReaderOnly.js";
import "../../../utilities/accessibility/visuallyHidden.css.js";
import { createValidHtmlId } from "../../../utilities/html/index.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { RadioButtonRecipe, CheckedCircleRecipe } from "./radiobutton.css.js";
import { InputWrapper, LabelRecipe, InputStyleRecipe, LabelStyle, indentedDescriptionStyle } from "./shared.css.js";
import { SelectionDescription, HelperTextWrapper } from "./shared.js";
const CustomRadioButton = ({ value, disabled, validity }) => {
  return jsx("span", { className: RadioButtonRecipe({
    disabled,
    validity: validity == null ? void 0 : validity.type
  }), "aria-hidden": true, children: jsx("span", { className: CheckedCircleRecipe({
    checked: value,
    disabled,
    validity: validity == null ? void 0 : validity.type
  }) }) });
};
const defaultRender = (radio, description) => jsxs(Fragment, { children: [radio, jsx("div", { className: indentedDescriptionStyle, children: description })] });
const RadioButton = forwardRef(function RadioButton2({
  value,
  onChange,
  disabled,
  validity,
  label,
  description,
  id = createValidHtmlId(label),
  hideLabel = false,
  canShowErrorMessage = false,
  className,
  render = defaultRender,
  // Input element props
  ...rest
}, ref) {
  const inputId = id;
  const labelId = `${id}-label`;
  const helperId = `${id}-helper`;
  const { helperTextProps, inputAriaProps } = useInputHelperText({
    id: helperId,
    validity,
    reserveSpaceForMessage: canShowErrorMessage
  });
  const radioButtonElement = jsx("span", { className: classNames(InputWrapper, className), ref, children: jsxs("label", { htmlFor: inputId, className: LabelRecipe({ disabled }), id: labelId, children: [jsx("input", { type: "radio", id: inputId, disabled, onChange, checked: value === true, className: InputStyleRecipe({ disabled }), tabIndex: 0, ...inputAriaProps, ...rest }), jsx(CustomRadioButton, { value, disabled, validity }), hideLabel ? jsx(ScreenReaderOnly, { children: label }) : jsx("span", { className: LabelStyle, children: label })] }) });
  const descriptionElement = description ? jsx(SelectionDescription, { disabled, children: description }) : void 0;
  return jsx(HelperTextWrapper, { ...helperTextProps, children: render(radioButtonElement, descriptionElement) });
});
export {
  RadioButton
};
